module.exports = __webpack_public_path__ + "static/media/mac.715ca96b.jpeg";